module.exports = {"TXTCLI_Current_Balance":{"id":"TXTCLI_Current_Balance","defaultMessage":"目前的余额","flags":["TRACK"],"track":"Current Balance"}}